import { TimeRange } from "../../Portfolio/PortfolioEnergyChart/types";
import { IReport } from "../../types";
import { IEnergyHeatmap } from "../Heatmap/types";

export interface IEnergyHeatmapBuilding extends IReport {
}


export const schema = 'AutomationApps.ReportsAndStatistics.Energy.HeatmapBuilding';